import { slugifyHeading } from './typography';

export function stripMatchingLeadingHeading(
  content: string,
  label: string,
): string {
  const trimmed = content.trimStart();
  const firstLine = trimmed.split('\n')[0];
  const match = firstLine.match(/^#{1,6}\s+(.+)$/);

  if (match && slugifyHeading(match[1].trim()) === slugifyHeading(label)) {
    return trimmed.slice(firstLine.length).trimStart();
  }

  return content;
}
